<template>
    <b-navbar sticky
        toggleable="md"
        id="menubar">
        <!-- Logo -->
        <b-navbar-brand href="/"
            class="logoHomeLink">
            <logo-horizontal></logo-horizontal>
        </b-navbar-brand>
        <!-- Hamburguer Icon -->
        <b-navbar-toggle target="nav-collapse"
            class="customToggler"></b-navbar-toggle>
        <!-- Menu -->
        <b-collapse id="nav-collapse"
            is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item right
                    class="menuItem"
                    href="#about">
                    Sobre Nós
                </b-nav-item>
                <b-nav-item right
                    class="menuItem"
                    href="#products">
                    Produtos
                </b-nav-item>
                <b-nav-item right
                    class="menuItem"
                    href="#download">
                    Download da App
                </b-nav-item>
                <b-nav-item right
                    class="menuItem"
                    href="login">
                    <i class="fas fa-sign-in-alt"></i>Login / Registo
                </b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import LogoHorizontal from '@/components/ui/LogoHorizontal.vue'

export default {
    name: 'MenuBar',
    components: {
        LogoHorizontal
    },
    props: {}
}
</script>
